<script>
import { FallbackImageElementMixin } from "%/dynamic-component-editor/standard-elements/image-element/fallback-image-element-mixin";
import { EpisodePageElementMixin } from "%/dynamic-component-editor/standard-pages/episode-page/episode-page-element-mixin";
import BaseImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/BaseImageElement.vue";

export default {
  name: "EpisodeCoverImage",
  elementPanelSettings: {
    displayName: "Cover Image",
    displayIcon: "material-symbols:image",
    elementType: "element",
    elementGroup: "episode",
  },
  extends: BaseImageElement,
  mixins: [FallbackImageElementMixin, EpisodePageElementMixin],
  computed: {
    imageSrc() {
      return this.entity.coverImage;
    },
  },
};
</script>
